import { t } from '@/utils/i18n'
import { useMount } from 'ahooks'
import { image, cal, productUtil, common, utils } from '@/utils'
import { ImageViewer, Image, Toast } from 'antd-mobile'
import styles from './index.module.less'
import { ProductItem, ProductDetail, returnProductsItem } from '@/types/product'
import { useState } from 'react'
import { useNavigate } from 'react-router-dom'
import dayjs from 'dayjs'
import { RightOutline } from 'antd-mobile-icons'

const { px2rem, concatenateImageUrl } = utils
const { imgFormatter } = image
const { moneyFormat } = cal
const { getMinUnits } = productUtil
const { getOrderProductReturnStatusLabel } = common

function ConfirmProductItem(props: {
  product: ProductItem
  currencySymbol: string
  isGoToDetail?: boolean
}) {
  const navigate = useNavigate()
  const { product, currencySymbol, isGoToDetail = true } = props
  const cloudProduct = product.cloudProduct || {}
  const saleProduct = product.saleProduct || {}
  const { productName, imageList, productStatus } = cloudProduct
  const details: ProductDetail[] = saleProduct.details || []
  const returnProducts: returnProductsItem[] = saleProduct.returnProducts || [] // 退货货品列表
  const specData = details[0] || {}
  const [imageUrl, setImageUrl] = useState(imageList?.[0] || '')
  const isMultiple = (productStatus & 4) === 4
  const remark = saleProduct.remark || ''

  async function initImg() {
    const url = (await imgFormatter(imageUrl, 140)) || ''
    setImageUrl(url)
  }

  function setReturnProduct() {
    details.forEach((item: ProductDetail) => {
      const returnList: returnProductsItem[] = []
      returnProducts.forEach((returnItem: returnProductsItem) => {
        returnItem.details?.forEach((returnSkuItem) => {
          if (item.skuId === returnSkuItem.skuId) {
            returnList.push({
              createTime: returnItem.createTime,
              returnProductId: returnSkuItem.returnProductId,
              orderId: returnSkuItem.orderId,
              unit1Quantity: returnSkuItem.unit1Quantity,
              unitIndex: returnSkuItem.unitIndex,
              status: returnItem.status,
              skuId: returnSkuItem.skuId,
            })
          }
        })
      })
      item.returnList = returnList
    })
  }

  useMount(() => {
    initImg()
    setReturnProduct()
  })

  async function previewImg() {
    if (imageList) {
      ImageViewer.Multi.show({
        images: [concatenateImageUrl(imageList?.[0])],
        defaultIndex: 0,
      })
    }
  }

  // 点击商品进入详情页
  function gotoDetail() {
    if (!isGoToDetail) return

    if (saleProduct.conflictStatus === 1 || saleProduct.conflictStatus === 2) {
      Toast.show(t('当前商品下架已删除'))
      return
    }

    navigate(`/product/detail/${saleProduct?.productId}`)
  }

  // 退货详情
  function onReturnDetailClick(orderId: string) {
    navigate(`/order/return-detail/${orderId}`)
  }

    // 转化退货数量
    function getReturnQty(qty: number, unitIndex: number) {
      const unitItem = product.product.unitList[unitIndex]
      return cal.divide(qty, unitItem.unitRatio) + unitItem.unitName
    }

  return (
    <div
      className={`${styles['order-product-item']} ${
        isMultiple ? styles['order-product-item-multiple'] : ''
      }`}
    >
      <div className={styles['product-box']}>
        <Image
          className={styles['product-img']}
          lazy
          fit="cover"
          src={imageUrl}
          onClick={previewImg}
        />
        <div className={styles['product-info']}>
          <div className={`${styles['product-name']} ep-2`} onClick={gotoDetail}>
            {productName}
          </div>
          {!isMultiple && (
            <div>
              <div className={styles['product-price']}>
                {currencySymbol}
                {moneyFormat(specData.selectPrice)}
              </div>
              <div className={styles['product-quantity']}>
                x{specData.quantity}
                {getMinUnits(specData.unitIndex, product, specData.quantity)}
              </div>
              {!!details.length &&
                details.map((detail, index) => {
                  return (
                    <div key={index}>
                      {!!(detail.returnList && detail.returnList.length) &&
                        detail.returnList.map((returnItem: any, j: number) => {
                          return (
                            <div
                              className={styles['product-return']}
                              key={j}
                              onClick={() => onReturnDetailClick(returnItem.orderId)}
                            >
                              {detail.returnList.length > 1 && (
                                <span className={styles['return-info']}>
                                  {dayjs(Number(returnItem.createTime)).format('MM.DD')}:
                                </span>
                              )}
                              <span className={styles['return-info']}>
                                {getReturnQty(returnItem.unit1Quantity, returnItem.unitIndex)}
                              </span>
                              <span className={styles['return-info']}>
                                {getOrderProductReturnStatusLabel(returnItem.status)}
                                <RightOutline fontSize={px2rem(20)} />
                              </span>
                            </div>
                          )
                        })}
                    </div>
                  )
                })}
            </div>
          )}
        </div>
      </div>

      {remark && (
        <div className={`${styles['product-remark']} ep-2`}>
          {t('备注')}：{remark}
        </div>
      )}

      {isMultiple && (
        <div>
          {!!details.length &&
            details.map((detail, index) => {
              const { elements } = detail
              const elementNames = elements.map((ele) => ele.elementName).join('，')
              return (
                <div key={index} className={styles['element-info']}>
                  <div className={`${styles['product-name']}`}>
                    <p className="ep-2">{elementNames}</p>
                    {!!detail.skuRemark && (
                      <p className={styles['product-sku-remark'] + ' ep'}>
                        {t('备注')}: {detail.skuRemark}
                      </p>
                    )}
                  </div>
                  <div>
                    <div className={styles['product-price']}>
                      {currencySymbol}
                      {moneyFormat(detail.selectPrice)}
                    </div>
                    <div className={styles['product-quantity']}>
                      x{detail.quantity}
                      {getMinUnits(detail.unitIndex, product, detail.quantity)}
                    </div>
                    {!!(detail.returnList && detail.returnList.length) &&
                      detail.returnList.map((returnItem: any, j: number) => {
                        return (
                          <div
                            className={styles['product-return']}
                            key={j}
                            onClick={() => onReturnDetailClick(returnItem.orderId)}
                          >
                            {detail.returnList.length > 1 && (
                              <span className={styles['return-info']}>
                                {dayjs(Number(returnItem.createTime)).format('MM.DD')}:
                              </span>
                            )}
                            <span className={styles['return-info']}>
                              {getReturnQty(returnItem.unit1Quantity, returnItem.unitIndex)}
                            </span>
                            <span className={styles['return-info']}>
                              {getOrderProductReturnStatusLabel(returnItem.status)}
                              <RightOutline fontSize={px2rem(20)} />
                            </span>
                          </div>
                        )
                      })}
                  </div>
                </div>
              )
            })}
        </div>
      )}
    </div>
  )
}

export default ConfirmProductItem
